import { apiAuth } from "../../http";

export const patchHighLight = async (id: string, body: any): Promise<any> => {
  const response = apiAuth()
    .patch(`/highlights/${id}`, body)
    .then(({ data }) => data);
  return response;
};
